module.exports = __webpack_public_path__ + "img/john.e9bb8250.png";